import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, onBeforeMount } from 'vue'
import { message as DcMessage } from '@dc-platform/dc-components'
import { selectForNumberValidate } from '@/utils/validate'
import { customerInvalid } from '@/api/yuntuSales/customerCenter'
import { listByParamCodes } from '@/api/common'
import { paramCodesDataFilter } from '@/utils/index'
import type { ParamCodeItem } from '@/typings/common'
import type { PotentialItem } from '@/typings/api/customerCenter'

const __default__ = { name: 'BecomeInvalid' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ['success'],
  setup(__props, { expose: __expose, emit: __emit }) {

const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const selectedData = ref<PotentialItem[]>([])
const formRef = ref()
const dataForm = ref<any>({})

const paramCodeData = ref<{
  [key: string]: ParamCodeItem[]
}>({
  lbu_invalid_reason: [] // 无效原因
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_invalid_reason']
  }).then((res) => {
    // 递归过滤业务参数状态
    res.data = paramCodesDataFilter(res.data, 0)
    paramCodeData.value = res.data
  })
}
onBeforeMount(() => {
  getByParamCodes()
})

const toggle = (data: PotentialItem[]) => {
  // 仅谈判 10与已注册11状态客户
  if (!data || !data.length) {
    DcMessage.error('请选择数据')
    return
  }
  const errorData = data.find((item: PotentialItem) => item.status !== 10 && item.status !== 11)
  if (errorData) {
    DcMessage.error('仅谈判与已注册状态客户可以提交')
    return
  }
  dataForm.value = {
    cosIdList: data.map((item: PotentialItem) => item.cosId),
    invalidId: undefined,
    invalidDesc: ''
  }
  selectedData.value = data
  visible.value = true
}

const emit = __emit
const handleBecomeInvalidOk = () => {
  formRef.value?.validate().then(() => {
    loading.value = true
    customerInvalid(dataForm.value)
      .then(() => {
        DcMessage.success('置为无效成功')
        visible.value = false
        emit('success')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
__expose({ toggle })

return (_ctx: any,_cache: any) => {
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosTextarea = _resolveComponent("CosTextarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_modal = _resolveComponent("cos-modal")!

  return (_openBlock(), _createBlock(_component_cos_modal, {
    visible: visible.value,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((visible).value = $event)),
    title: "置为无效",
    width: "670px",
    "confirm-loading": loading.value,
    onOk: handleBecomeInvalidOk
  }, {
    default: _withCtx(() => [
      (visible.value)
        ? (_openBlock(), _createBlock(_component_a_form, {
            key: 0,
            model: dataForm.value,
            ref_key: "formRef",
            ref: formRef
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, {
                name: "cosIdList",
                label: "客户名称",
                rules: {
          message: '请选择',
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosSelect, {
                    value: dataForm.value.cosIdList,
                    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((dataForm.value.cosIdList) = $event)),
                    options: selectedData.value,
                    fieldNames: { label: 'customerName', value: 'cosId' },
                    mode: "multiple",
                    "max-tag-count": 100,
                    disabled: ""
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, {
                name: "invalidId",
                label: "无效原因",
                span: 24,
                rules: {
          message: '请选择',
          validator: _unref(selectForNumberValidate),
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ParamCodesSelect, {
                    value: dataForm.value.invalidId,
                    "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.value.invalidId) = $event)),
                    options: paramCodeData.value.lbu_invalid_reason,
                    allowClear: ""
                  }, null, 8, ["value", "options"])
                ]),
                _: 1
              }, 8, ["rules"]),
              _createVNode(_component_a_form_item, {
                name: "invalidDesc",
                label: "说明",
                rules: {
          message: '请输入',
          required: true
        }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CosTextarea, {
                    value: dataForm.value.invalidDesc,
                    "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.value.invalidDesc) = $event)),
                    maxlength: 2000
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "confirm-loading"]))
}
}

})